import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";

import Footer from "../components/Footer";
//import ViewContent from '../containers/main/ViewContent';

class Error404 extends Component {
  _onMain = () => {
    const { history } = this.props;
    history.push("/");
  };
  render() {
    return (
      <Fragment>
        <div style={{ paddingTop: 80 }}>
          <div
            style={{
              width: "100%",
              height: 500,
              textAlign: "center",
              color: "#ffffff",
              paddingTop: 150,
              fontSize: 24,
              fontWeight: "800",
            }}
          >
            <p style={{ fontSize: 18 }}>헉!!! 죄송합니다.</p>
            <p style={{ fontSize: 18, paddingTop: 20 }}>
              요청하신 페이지를 찾을 수 없습니다.
            </p>
            <p style={{ fontSize: 24, paddingTop: 25 }}>404 Not Found</p>

            <p
              style={{
                fontSize: 18,
                paddingTop: 30,
                color: "#ff5d24",
                cursor: "pointer",
              }}
              onClick={this._onMain}
            >
              메인으로 이동
            </p>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Error404));
